"use strict";

/**
 * Main Class and namespace
 * @class Proj
 * @singletone
 */
var Proj = (function(proj) {
	proj.interfaceName = '';

	proj.init = function() {
		proj.interfaceName = $('body').data("interfaceName");
	};

	return proj;

})(Proj || {});

/** @type {String} url для ajax запроса */
var AJAX_URI = '/json/';

/** @type {String} id сессии из командной строки */
var SESS_ID = '';
if (window.location.toString().match(/SESS_ID=(\d+)/))
	SESS_ID = RegExp.$1;
//------------------------------------------------------------------------------
/* @param {Function} handler Обработчик */
Proj.getJSON = function(data, handler, filesend) {
	if (SESS_ID)
		data['SESS_ID'] = SESS_ID;
	$.post(AJAX_URI, data, handler, 'json');

	// $.ajax({
	// 	type: "POST",
	// 	url: AJAX_URI,
	// 	data: data,
	// 	dataType: "json",
	// 	success: handler,
	// 	error: handler
	// });
}

/**
	*  Обработчик fancybox
	*/
Proj.FancyBox = function(){
	$(".fancybox").fancybox();
}

/**
	*  Обработчик для параллакса
	*/
Proj.Parallax = function(){
	var $objs = $('.parallax-objects .parallax'),
	$window = $(window),
	$document = $(document);

	function init(){
		scroll();
	}

	function scroll(){
		$objs.each(function(){
			var $this = $(this),
			level1top = 320 - $window.scrollTop()*0.9,
			level2top = 320 - $window.scrollTop()*0.7,
			level3top = 320 - $window.scrollTop()*0.4,
			level4top = 320 - $window.scrollTop()*0.2;
			
			if($this.hasClass('obj1'))
				$this.css('top', level1top);
			else if($this.hasClass('obj2'))
				$this.css('top', level2top);
			else if($this.hasClass('obj3'))
				$this.css('top', level3top);
			else if($this.hasClass('obj4'))
				$this.css('top', level4top);
		});
	}

	return {
		init: init,
		scroll: scroll
	}
}();

/**
	*  Обработчик для главного меню
	*/
Proj.MainMenu = function(){
	var $layout = $('.layout'),
	$header_big = $layout.find('header.big'),
	$header_small = $layout.find('header.small'),
	$menu_btn = $header_small.find('.menu-ico'),
	$close_menu = $header_small.find('.main-menu .close'),
	$window = $(window),
	$document = $(document);

	function init(){
		$menu_btn.on('click', function(){
			$header_small.toggleClass('active');
		});
		$close_menu.on('click', function(){
			$header_small.removeClass('active');
		});

		scroll();
	}

	function scroll(){
		if($window.height() <= 768){
			$header_big.addClass('hide');
			$header_small.removeClass('hide');

			if(Proj.interfaceName === 'home_page')
				$layout.addClass('top-padded-main');
			else
				$layout.addClass('top-padded');
		}else{
			if(Proj.interfaceName === 'home_page')
				$layout.removeClass('top-padded-main');
			else
				$layout.removeClass('top-padded');
			$header_big.removeClass('hide');

			if((Proj.interfaceName === 'home_page' && $window.scrollTop() > 221) || (Proj.interfaceName !== 'home_page' && $window.scrollTop() > 116)){
				$header_small.removeClass('hide');
			}else{
				$header_small.addClass('hide');
			}
		}
	}

	return {
		init: init,
		resize: scroll,
		scroll: scroll
	};
}();

/**
	*  Обработчик открытия фильтров
	*/
Proj.ShowFilters = function(){
	var $filters = $('.product-filters'),
	$btn = $filters.find('.open-filter'),
	$form = $filters.find('form');

	return {
		init: function(){
			$btn.on('click', function(){
				$(this).remove();
				$form.slideDown({
					duration: 200,
					progress: function() {
						Proj.Footer.resize();
					}
				});
			})
		}
	};
}();

/**
	*  Обработчик фильтров
	*/
Proj.Filters = function(){
	var $filters = $('.product-filters'),
	$selects = $filters.find('.f-third'),
	$manufacturer_select = $selects.find('select[name=manufacturer]'),
	$trade_mark_select = $selects.find('select[name=trade_mark]');

	return {
		init: function(){
			$manufacturer_select.on('change', function(){
				$trade_mark_select.val(0);
			});
			$trade_mark_select.on('change', function(){
				$manufacturer_select.val(0);
			});
		}
	};
}();

/**
	*  Обработчик открытия подсказок фильтров
	*/
Proj.FilterHint = function(){
	var $filters = $('.product-filters'),
	$btn = $filters.find('.show-hint'),
	$hint = $filters.find('.f-hint'),
	$close_btn = $hint.find('.h-close');

	return {
		init: function(){
			$btn.on('click', function(){
				$hint.fadeIn();
			});
			$close_btn.on('click', function(){
				$hint.fadeOut();
			});
		}
	};
}();

/**
	*  Обработчик кнопки вверх
	*/
Proj.GoUp = function(){
	var $btn = $('.go-up-btn'),
	$window = $(window);

	function scroll(fast){
		if($window.scrollTop() > 700){
			if(fast)
				$btn.show();
			else
				$btn.fadeIn();
		}else{
			if(fast)
				$btn.hide();
			else
				$btn.fadeOut();
		}
	}

	return {
		init: function(){
			$btn.on('click', function(){
				$("html, body").animate({ scrollTop: "0px" }, 500);
			});
			scroll(true);
		},
		scroll: function(){
			scroll(false);
		}
	};
}();

/**
	*  Обработчик для слайдера каталога на главной
	*/
Proj.CatalogSlider = function(){
	var last_width = 0;
	function ScaleSlider() {
		var $prototype = $('.prod-cat .slider_prototype');
		if($prototype.length == 0)
			return;

		$prototype.each(function(){
			var $this = $(this),
			$slider = $this.parent(),
			slider_id = $this.data('sliderId'),
			width = $slider.innerWidth(),
			slidesCount = parseInt((width-152)/230);
			width = slidesCount*230;

			var options = {
				$AutoPlay: false,                                    //[Optional] Whether to auto play, to enable slideshow, this option must be set to true, default value is false
				$AutoPlaySteps: slidesCount,                                  //[Optional] Steps to go for each navigation request (this options applys only when slideshow disabled), the default value is 1
				$AutoPlayInterval: 4000,                            //[Optional] Interval (in milliseconds) to go for next slide since the previous stopped if the slider is auto playing, default value is 3000
				$PauseOnHover: 1,                               //[Optional] Whether to pause when mouse over if a slider is auto playing, 0 no pause, 1 pause for desktop, 2 pause for touch device, 3 pause for desktop and touch device, 4 freeze for desktop, 8 freeze for touch device, 12 freeze for desktop and touch device, default value is 1

				$ArrowKeyNavigation: false,                         //[Optional] Allows keyboard (arrow key) navigation or not, default value is false
				$SlideDuration: 1500/slidesCount,                                //[Optional] Specifies default duration (swipe) for slide in milliseconds, default value is 500
				$MinDragOffsetToSlide: 100,                          //[Optional] Minimum drag offset to trigger slide , default value is 20
				$SlideWidth: 230,                                   //[Optional] Width of every slide in pixels, default value is width of 'slides' container
				$SlideHeight: 220,                                //[Optional] Height of every slide in pixels, default value is height of 'slides' container
				$SlideSpacing: 0,                                   //[Optional] Space between each slide in pixels, default value is 0
				$DisplayPieces: slidesCount,                                  //[Optional] Number of pieces to display (the slideshow would be disabled if the value is set to greater than 1), the default value is 1
				$ParkingPosition: 0,                              //[Optional] The offset position to park slide (this options applys only when slideshow disabled), default value is 0.
				$UISearchMode: 1,                                   //[Optional] The way (0 parellel, 1 recursive, default value is 1) to search UI components (slides container, loading screen, navigator container, arrow navigator container, thumbnail navigator container etc).
				$PlayOrientation: 1,                                //[Optional] Orientation to play slide (for auto play, navigation), 1 horizental, 2 vertical, 5 horizental reverse, 6 vertical reverse, default value is 1
				$DragOrientation: 1,                                //[Optional] Orientation to drag slide, 0 no drag, 1 horizental, 2 vertical, 3 either, default value is 1 (Note that the $DragOrientation should be the same as $PlayOrientation when $DisplayPieces is greater than 1, or parking position is not 0)

				$BulletNavigatorOptions: {                                //[Optional] Options to specify and enable navigator or not
					$Class: $JssorBulletNavigator$,                       //[Required] Class to create navigator instance
					$ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 1,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: slidesCount,                                      //[Optional] Steps to go for each navigation request, default value is 1
					$Lanes: 1,                                      //[Optional] Specify lanes to arrange items, default value is 1
					$SpacingX: 20,                                   //[Optional] Horizontal space between each item in pixel, default value is 0
					$SpacingY: 0,                                   //[Optional] Vertical space between each item in pixel, default value is 0
					$Orientation: 1                                 //[Optional] The orientation of the navigator, 1 horizontal, 2 vertical, default value is 1
				},

				$ArrowNavigatorOptions: {
					$Class: $JssorArrowNavigator$,              //[Requried] Class to create arrow navigator instance
					$ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 2,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: slidesCount                                      //[Optional] Steps to go for each navigation request, default value is 1
				}
			};
			if (width && last_width != width){
				last_width = width;
				$('#'+slider_id).remove();
				var $clone = $this.clone();
				$clone.removeAttr('class').removeAttr('data-slider-id').attr('id', slider_id);
				$clone.appendTo($slider);
				$('#'+slider_id+', #'+slider_id+' .slider_wrapper').css('width', width);
				var jssor_slider = new $JssorSlider$(slider_id, options);
			}
		});
	}

	return {
		init : function(){
			ScaleSlider();
			$(window).bind("resize", ScaleSlider);
			$(window).bind("orientationchange", ScaleSlider);
		}
	}
}();

/**
	*  Обработчик для слайдера баннеров на главной
	*/
Proj.BannersSlider = function(){
	var last_width = 0;
	function ScaleSlider() {
		var $prototype = $('.main-banners .slider_prototype');
		if($prototype.length == 0)
			return;

		$prototype.each(function(){
			var $this = $(this),
			$slider = $this.parent(),
			slider_id = $this.data('sliderId'),
			width = 879;

			var options = {
				$AutoPlay: true,                                    //[Optional] Whether to auto play, to enable slideshow, this option must be set to true, default value is false
				$AutoPlaySteps: 1,                                  //[Optional] Steps to go for each navigation request (this options applys only when slideshow disabled), the default value is 1
				$AutoPlayInterval: 9000,                            //[Optional] Interval (in milliseconds) to go for next slide since the previous stopped if the slider is auto playing, default value is 3000
				$PauseOnHover: 1,                               //[Optional] Whether to pause when mouse over if a slider is auto playing, 0 no pause, 1 pause for desktop, 2 pause for touch device, 3 pause for desktop and touch device, 4 freeze for desktop, 8 freeze for touch device, 12 freeze for desktop and touch device, default value is 1

				$ArrowKeyNavigation: false,                         //[Optional] Allows keyboard (arrow key) navigation or not, default value is false
				$SlideDuration: 500,                                //[Optional] Specifies default duration (swipe) for slide in milliseconds, default value is 500
				$MinDragOffsetToSlide: 100,                          //[Optional] Minimum drag offset to trigger slide , default value is 20
				$SlideWidth: width,                                   //[Optional] Width of every slide in pixels, default value is width of 'slides' container
				$SlideHeight: 450,                                //[Optional] Height of every slide in pixels, default value is height of 'slides' container
				$SlideSpacing: 0,                                   //[Optional] Space between each slide in pixels, default value is 0
				$DisplayPieces: 1,                                  //[Optional] Number of pieces to display (the slideshow would be disabled if the value is set to greater than 1), the default value is 1
				$ParkingPosition: 0,                              //[Optional] The offset position to park slide (this options applys only when slideshow disabled), default value is 0.
				$UISearchMode: 1,                                   //[Optional] The way (0 parellel, 1 recursive, default value is 1) to search UI components (slides container, loading screen, navigator container, arrow navigator container, thumbnail navigator container etc).
				$PlayOrientation: 1,                                //[Optional] Orientation to play slide (for auto play, navigation), 1 horizental, 2 vertical, 5 horizental reverse, 6 vertical reverse, default value is 1
				$DragOrientation: 1,                                //[Optional] Orientation to drag slide, 0 no drag, 1 horizental, 2 vertical, 3 either, default value is 1 (Note that the $DragOrientation should be the same as $PlayOrientation when $DisplayPieces is greater than 1, or parking position is not 0)

				$BulletNavigatorOptions: {                                //[Optional] Options to specify and enable navigator or not
					$Class: $JssorBulletNavigator$,                       //[Required] Class to create navigator instance
					$ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 1,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: 1,                                      //[Optional] Steps to go for each navigation request, default value is 1
					$Lanes: 1,                                      //[Optional] Specify lanes to arrange items, default value is 1
					$SpacingX: 20,                                   //[Optional] Horizontal space between each item in pixel, default value is 0
					$SpacingY: 0,                                   //[Optional] Vertical space between each item in pixel, default value is 0
					$Orientation: 1                                 //[Optional] The orientation of the navigator, 1 horizontal, 2 vertical, default value is 1
				},

				$ArrowNavigatorOptions: {
					$Class: $JssorArrowNavigator$,              //[Requried] Class to create arrow navigator instance
					$ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 2,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: 1                                      //[Optional] Steps to go for each navigation request, default value is 1
				}
			};
			

			if (width && last_width != width){
				last_width = width;
				$('#'+slider_id).remove();
				var $clone = $this.clone();
				$clone.removeAttr('class').removeAttr('data-slider-id').attr('id', slider_id);
				$clone.appendTo($slider);
				$('#'+slider_id+', #'+slider_id+' .slider_wrapper').css('width', width);
				var jssor_slider = new $JssorSlider$(slider_id, options);
			}
		});

		$prototype.remove();
	}

	return {
		init : function(){
			ScaleSlider();
			//$(window).bind("resize", ScaleSlider);
			//$(window).bind("orientationchange", ScaleSlider);
		}
	}
}();

Proj.Fallbacks = function(){
	return {
		init : function(){
			var ua = window.navigator.userAgent,
			ms11 = ua.indexOf("Mozilla/5");
			//alert(ua);
			// if(ms11 > -1){
			// 	$('select').css({'background-image':'none', 'padding-right':'0px'});
			// }
		}
	}
}();

/**
	*  Обработчик для сквозного слайдера партнеров
	*/
Proj.PartnersSlider = function(){
	var last_width = 0;
	function ScaleSlider() {
		var $prototype = $('.partners .slider_prototype');
		if($prototype.length == 0)
			return;

		$prototype.each(function(){
			var $this = $(this),
			$slider = $this.parent(),
			slider_id = $this.data('sliderId'),
			width = $slider.innerWidth(),
			slidesCount = parseInt((width-140)/210);
			width = slidesCount*210;

			var options = {
				$AutoPlay: false,                                    //[Optional] Whether to auto play, to enable slideshow, this option must be set to true, default value is false
				$AutoPlaySteps: slidesCount,                                  //[Optional] Steps to go for each navigation request (this options applys only when slideshow disabled), the default value is 1
				$AutoPlayInterval: 4000,                            //[Optional] Interval (in milliseconds) to go for next slide since the previous stopped if the slider is auto playing, default value is 3000
				$PauseOnHover: 1,                               //[Optional] Whether to pause when mouse over if a slider is auto playing, 0 no pause, 1 pause for desktop, 2 pause for touch device, 3 pause for desktop and touch device, 4 freeze for desktop, 8 freeze for touch device, 12 freeze for desktop and touch device, default value is 1
				$HWA: false,

				$ArrowKeyNavigation: false,                         //[Optional] Allows keyboard (arrow key) navigation or not, default value is false
				$SlideDuration: 1500/slidesCount,                                //[Optional] Specifies default duration (swipe) for slide in milliseconds, default value is 500
				$MinDragOffsetToSlide: 100,                          //[Optional] Minimum drag offset to trigger slide , default value is 20
				$SlideWidth: 210,                                   //[Optional] Width of every slide in pixels, default value is width of 'slides' container
				$SlideHeight: 90,                                //[Optional] Height of every slide in pixels, default value is height of 'slides' container
				$SlideSpacing: 0,                                   //[Optional] Space between each slide in pixels, default value is 0
				$DisplayPieces: slidesCount,                        //[Optional] Number of pieces to display (the slideshow would be disabled if the value is set to greater than 1), the default value is 1
				$ParkingPosition: 0,                              //[Optional] The offset position to park slide (this options applys only when slideshow disabled), default value is 0.
				$UISearchMode: 1,                                   //[Optional] The way (0 parellel, 1 recursive, default value is 1) to search UI components (slides container, loading screen, navigator container, arrow navigator container, thumbnail navigator container etc).
				$PlayOrientation: 1,                                //[Optional] Orientation to play slide (for auto play, navigation), 1 horizental, 2 vertical, 5 horizental reverse, 6 vertical reverse, default value is 1
				$DragOrientation: 1,                                //[Optional] Orientation to drag slide, 0 no drag, 1 horizental, 2 vertical, 3 either, default value is 1 (Note that the $DragOrientation should be the same as $PlayOrientation when $DisplayPieces is greater than 1, or parking position is not 0)

				$BulletNavigatorOptions: {                                //[Optional] Options to specify and enable navigator or not
					$Class: $JssorBulletNavigator$,                       //[Required] Class to create navigator instance
					$ChanceToShow: 0,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 1,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: slidesCount,                                      //[Optional] Steps to go for each navigation request, default value is 1
					$Lanes: 1,                                      //[Optional] Specify lanes to arrange items, default value is 1
					$SpacingX: 20,                                   //[Optional] Horizontal space between each item in pixel, default value is 0
					$SpacingY: 0,                                   //[Optional] Vertical space between each item in pixel, default value is 0
					$Orientation: 1                                 //[Optional] The orientation of the navigator, 1 horizontal, 2 vertical, default value is 1
				},

				$ArrowNavigatorOptions: {
					$Class: $JssorArrowNavigator$,              //[Requried] Class to create arrow navigator instance
					$ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 2,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: slidesCount                                      //[Optional] Steps to go for each navigation request, default value is 1
				}
			};
			
			if (width && last_width != width){
				last_width = width;
				$('#'+slider_id).remove();
				var $clone = $this.clone();
				$clone.removeAttr('class').removeAttr('data-slider-id').attr('id', slider_id);
				$clone.appendTo($slider);
				$('#'+slider_id+', #'+slider_id+' .slider_wrapper').css('width', width);
				var jssor_slider = new $JssorSlider$(slider_id, options);
			}
		});
	}

	return {
		init : function(){
			ScaleSlider();
			$(window).bind("resize", ScaleSlider);
			$(window).bind("orientationchange", ScaleSlider);
		}
	}
}();

/**
	*  Обработчик для слайдера галерей картинок новостей
	*/
Proj.NewsSlider = function(){
	var last_width = 0;
	function ScaleSlider() {
		var $prototype = $('.news.slider_prototype');
		if($prototype.length == 0)
			return;

		$prototype.each(function(){
			var $this = $(this),
			$slider = $this.parent(),
			slider_id = $this.data('sliderId'),
			width = $slider.innerWidth(),
			slidesCount = parseInt((width-140)/210);
			width = slidesCount*210;

			var options = {
				$AutoPlay: true,                                    //[Optional] Whether to auto play, to enable slideshow, this option must be set to true, default value is false
				$AutoPlaySteps: slidesCount,                                  //[Optional] Steps to go for each navigation request (this options applys only when slideshow disabled), the default value is 1
				$AutoPlayInterval: 4000,                            //[Optional] Interval (in milliseconds) to go for next slide since the previous stopped if the slider is auto playing, default value is 3000
				$PauseOnHover: 1,                               //[Optional] Whether to pause when mouse over if a slider is auto playing, 0 no pause, 1 pause for desktop, 2 pause for touch device, 3 pause for desktop and touch device, 4 freeze for desktop, 8 freeze for touch device, 12 freeze for desktop and touch device, default value is 1
				$HWA: false,

				$ArrowKeyNavigation: false,                         //[Optional] Allows keyboard (arrow key) navigation or not, default value is false
				$SlideDuration: 1500/slidesCount,                                //[Optional] Specifies default duration (swipe) for slide in milliseconds, default value is 500
				$MinDragOffsetToSlide: 100,                          //[Optional] Minimum drag offset to trigger slide , default value is 20
				$SlideWidth: 210,                                   //[Optional] Width of every slide in pixels, default value is width of 'slides' container
				$SlideHeight: 0,                                //[Optional] Height of every slide in pixels, default value is height of 'slides' container
				$SlideSpacing: 10,                                   //[Optional] Space between each slide in pixels, default value is 0
				$DisplayPieces: slidesCount,                        //[Optional] Number of pieces to display (the slideshow would be disabled if the value is set to greater than 1), the default value is 1
				$ParkingPosition: 0,                              //[Optional] The offset position to park slide (this options applys only when slideshow disabled), default value is 0.
				$UISearchMode: 1,                                   //[Optional] The way (0 parellel, 1 recursive, default value is 1) to search UI components (slides container, loading screen, navigator container, arrow navigator container, thumbnail navigator container etc).
				$PlayOrientation: 1,                                //[Optional] Orientation to play slide (for auto play, navigation), 1 horizental, 2 vertical, 5 horizental reverse, 6 vertical reverse, default value is 1
				$DragOrientation: 1,                                //[Optional] Orientation to drag slide, 0 no drag, 1 horizental, 2 vertical, 3 either, default value is 1 (Note that the $DragOrientation should be the same as $PlayOrientation when $DisplayPieces is greater than 1, or parking position is not 0)

				$BulletNavigatorOptions: {                                //[Optional] Options to specify and enable navigator or not
					$Class: $JssorBulletNavigator$,                       //[Required] Class to create navigator instance
					$ChanceToShow: 0,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 1,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: slidesCount,                                      //[Optional] Steps to go for each navigation request, default value is 1
					$Lanes: 1,                                      //[Optional] Specify lanes to arrange items, default value is 1
					$SpacingX: 20,                                   //[Optional] Horizontal space between each item in pixel, default value is 0
					$SpacingY: 0,                                   //[Optional] Vertical space between each item in pixel, default value is 0
					$Orientation: 1                                 //[Optional] The orientation of the navigator, 1 horizontal, 2 vertical, default value is 1
				},

				$ArrowNavigatorOptions: {
					$Class: $JssorArrowNavigator$,              //[Requried] Class to create arrow navigator instance
					$ChanceToShow: 2,                               //[Required] 0 Never, 1 Mouse Over, 2 Always
					$AutoCenter: 0,                                 //[Optional] Auto center navigator in parent container, 0 None, 1 Horizontal, 2 Vertical, 3 Both, default value is 0
					$Steps: slidesCount                                      //[Optional] Steps to go for each navigation request, default value is 1
				}
			};
			
			if (width && last_width != width){
				last_width = width;
				$('#'+slider_id).remove();
				var $clone = $this.clone();
				$clone.removeAttr('class').removeAttr('data-slider-id').attr('id', slider_id);
				$clone.appendTo($slider);
				$('#'+slider_id+', #'+slider_id+' .slider_wrapper').css('width', width);
				var jssor_slider = new $JssorSlider$(slider_id, options);
			}
		});
	}

	return {
		init : function(){
			ScaleSlider();
			$(window).bind("resize", ScaleSlider);
			$(window).bind("orientationchange", ScaleSlider);
		}
	}
}();

/**
	*  Обработчик для страницы товара
	*/
Proj.ProductPage = function(){
	var $prod_texts = $('.product-texts .t-item'),
	$quantity_controls = $('.quantity-controls'),
	$minus = $quantity_controls.find('.minus'),
	$plus = $quantity_controls.find('.plus'),
	$quantity = $quantity_controls.find('.quantity');

	function fixQuantityValue(value){
		if(value < 1)
			value = 1;

		if(value < 10)
			value = '0'+value;

		$quantity.val(value);
	}

	return {
		init : function(){
			$prod_texts.each(function(i){
				if((i == 0 && $prod_texts.length > 1) || (i == 2 && $prod_texts.length > 3))
					$(this).after(' <div class="vl"></div> ');
			});

			$minus.on('click', function(){
				var value = parseInt($quantity.val());
				value--;
				fixQuantityValue(value);
			});
			$plus.on('click', function(){
				var value = parseInt($quantity.val());
				value++;
				fixQuantityValue(value);
			});
			$quantity.on('change', function(){
				var value = parseInt($quantity.val());
				if(isNaN(value))
					value = 1;
				fixQuantityValue(value);
			});
		}
	}
}();

/**
	*  Обработчик для страницы каталога товара второго уровня
	*/
Proj.CatalogGroupPage = function(){
	var $prods = $('.prods-with-pics .p-item');
	return {
		init : function(){
			$prods.each(function(i){
				if((i+4)%3 == 0)
					$(this).after(' <hr/> ');
			});
		}
	}
}();

/**
	*  Обработчик для страницы каталога
	*/
Proj.CatalogPage = function(){
	var $cat_items = $('.catalog-content .category .c-item');


	return {
		init : function(){
			$cat_items.on('click', function(){
				$cat_items.removeClass('active');
				$(this).toggleClass('active');
			});
		}
	}
}();

/**
	*  Обработчик для футера товара
	*/
Proj.Footer = function(){
	var $layout = $('.layout'),
	$footer = $('footer'),
	$window = $(window);

	function init(){
		$layout.css('padding-bottom', $footer.outerHeight());
		resize();
	}

	function resize(){
		$layout.outerHeight('auto');
		var w_height = $window.height();
		if(w_height > $layout.outerHeight())
			$layout.outerHeight(w_height);
	}

	// setTimeout(resize, 1000);

	return {
		init: init,
		resize: resize
	}
}();

/**
	*  Обработчик для FAQ
	*/
Proj.Questions = function(){
	var $questions = $('.questions-list .question-item .q-question');

	function init(){
		$questions.on('click', function(){
			$(this).parent().find('.q-answer').slideToggle('fast');
		});
	}

	return {
		init: init
	}
}();

/**
	*  Обработчик для встроенной ajax формы
	*/
Proj.InlineAjaxForm = function(){
	var opt = { selector: ".form-replace" },
	$formreplace = $(opt.selector),
	issend = false,
	$form = $();

	function showForm(json, d){
		if(json && json.content){
			issend = false;
			waitChange();
			var $content = $(json.content);
			$formreplace.after($content).remove();
			form_file_upload();
			Proj.Footer.resize();

			$form = $(".form-content form");
			if(d.form_name == 'form_vacancy'){
				var options = {
					url: '/json/',
					data: { _do: "submit_form" },
					dataType: 'json',
					success:    function(data) {
						issend = false;
						waitChange();
						answer(data);
						// if(d.form_name == 'form_preorder_excursion')
						// 	yaCounter33289018.reachGoal('bron');
					},
					beforeSubmit:  function(){
						if(!issend)
						{
							issend = true;
							waitChange();
							return true;
						}
						return false;
					}
				};

				//pass options to ajaxForm
				$form.ajaxForm(options);
			}else{
				$form.on("submit", function(e){ e.preventDefault(); precheck(this, d); return false;});
			}
		}
	}

	function precheck(el, d){
		$(el).find(".error").removeClass("error");
		var params = $(el).serializeArray();
		params.push({ name: "_do",
					  value: "submit_form" });

		if(!issend){
			issend = true;
			waitChange();
			Proj.getJSON(params, function(data){
				issend = false;
				waitChange();
				answer(data);
				//if(data.status == "ok"){
				// 	yaCounter33289018.reachGoal('bron');	
				//}
			});
		}
	}

	function form_file_upload(){
		var $input = $('input[type=file]'),
		label = $input.parent().find('.label').remove().text();
		$input.wrap('<div class="fileUpload"></div>').before('<span class="btn"></span><span class="f-texts"><span class="f-h">'+label+'</span><span class="filepath">файл не выбран</span></span>').change(function (){
			var filepath = $(this).val();
			$(".filepath").html(filepath);
		});
		$('.fileUpload .btn').click(function(){
			$(this).parent().find('input[type=file]').click();
			return false;
		});
	}

	function answer(json){
		if(json.status == "ok"){
			$('.form-content').html(json.content);
		}else{
			if(json.errors){
				$form.find('.error').removeClass('error');
				for(var i=0;i<json.errors.length;i++){
					var attr = ".attr-"+json.errors[i];
					$form.find(attr).addClass("error");
          grecaptcha.reset();
				}
			}
		}
	}

	function waitChange(){
		if(issend)
			$.fancybox.showLoading();
		else
			$.fancybox.hideLoading();
	}

	return {
		init: function(){
			if($formreplace.length){
				if(!issend){
					issend = true;
					waitChange();
					var form_name = $formreplace.data("formName");

					var d = {
						_do: 'get_form',
						form_name: form_name
					};

					Proj.getJSON(d, function(json){
						showForm(json, d);
					});
				}
			}
		}
	}
}();

/**
 * Обработчик для кастомных чекбоксов
 */
Proj.Checkbox = function(){
	$('input[type=checkbox].css-checkbox').click(function(){
		var $div = $(this).parent().find('.css-label .check');
		if($div.hasClass('checked'))
			$div.removeClass('checked');
		else
			$div.addClass('checked');
	});
};

/**
 * Обработчик для страницы бизнес-форума премии
 */
Proj.VacancyCat = function() {
	var $menu_items = $('.vacancy-cat .vacancy-select'),
	$vacancy_items = $('.vacancy-description');

	$menu_items.on('click', function(){
		var $this = $(this);
		if($this.hasClass('active'))
			return false;
		$menu_items.removeClass('active');
		$this.addClass('active');
		var vacancy_id = $(this).data('vacancyId');
		$vacancy_items.removeClass('active');
		$vacancy_items.filter('[data-vacancy-id="'+vacancy_id+'"]').addClass('active');
	});
}

/**
	*  Обработчик для всплывающей ajax формы
	*/
Proj.PopAjaxForm = function(){
	var opt = { selector: ".pop_up_btn" },
	issend = false,
	$form = $();

	var fancyBoxParams = {
		padding: 20,
		maxWidth: 490,
		minWidth: 490,
		height: 'auto',
		fitToView: true
	};

	function showForm(json, d){
		if(json && json.content){
			issend = false;
			waitChange();
			var $content = $(json.content);
			$content = form_placeholders($content);
			$.fancybox($.extend(true, {}, fancyBoxParams, {content: $content}));

			// var options = {
			// 	url: '/json/',
			// 	data: { _do: "submit_form" },
			// 	dataType: 'json',
			// 	success:    function(data) {
			// 		issend = false;
			// 		waitChange();
			// 		answer(data);
			// 		if(data.status == "ok" && d.form_name == 'form_order'){
			// 			var $basket = $('#basket-checkout');
			// 			$basket.fadeOut('fast', function(){
			// 				setTimeout(function(){
			// 					var ev = new $.Event('clearbasket');
			// 					$basket.trigger(ev);
			// 				}, 2000);
			// 			});
			// 		}
			// 		// 	yaCounter33289018.reachGoal('bron');
			// 	},
			// 	beforeSubmit:  function(){
			// 		if(!issend)
			// 		{
			// 			issend = true;
			// 			waitChange();
			// 			return true;
			// 		}
			// 		return false;
			// 	}
			// };

			// pass options to ajaxForm
			$form = $(".pop_up_form form");
			$form.on("submit", function(e){ e.preventDefault(); precheck(this, d); return false;});
			// $form.ajaxForm(options);
		}
	}

	function precheck(el, d){
		$(el).find(".error").removeClass("error");
		var params = $(el).serializeArray();
		params.push({ name: "_do",
					  value: "submit_form" });
		if(!issend){
			issend = true;
			waitChange();
			Proj.getJSON(params, function(data){
				issend = false;
				waitChange();
				answer(data);
				if(data.status == "ok" && d.form_name == 'form_order'){
					var $basket = $('#basket-checkout');
					$basket.fadeOut('fast', function(){
						setTimeout(function(){
							var ev = new $.Event('clearbasket');
							$basket.trigger(ev);
						}, 2000);
					});
				}
				// 	yaCounter33289018.reachGoal('bron');
			});
		}
	}

	function form_placeholders($content){
		var ua = window.navigator.userAgent,
		msie = ua.indexOf("MSIE ");
		if(msie > -1)
			return $content;
		$content.find('.label').each(function(){
			var $this = $(this);
			var text = $this.text().trim();
			$this.parent().find('input, textarea').attr('placeholder', text);
			$this.parent().find('select option[value=-1]').html(text);
      if ($this.parent().find('input, textarea').attr('type') != 'checkbox') {
    			$this.remove();
      }
		});
		return $content;
	}

	function answer(json){
		if(json.status == "ok"){
			$('.pop_up_form .send_form input[type=text], .pop_up_form .send_form textarea').attr('value', '');
			$('.pop_up_form .send_form').hide();
			$('.pop_up_form .text').hide();
			$('.pop_up_form .answer').html(json.content);
			$('.pop_up_form .answer').show();
			$.fancybox.update();

		}else{
			if(json.errors){
				$form.find('.error').removeClass('error');
				for(var i=0;i<json.errors.length;i++){
					var attr = ".attr-"+json.errors[i];
					$form.find(attr).addClass("error");
          grecaptcha.reset();
				}
			}
		}
	}

	function waitChange(){
		if(issend)
			$.fancybox.showLoading();
		else
			$.fancybox.hideLoading();
	}

	return {
		init: function(){
			$(opt.selector).on("click", function(e){
				e.preventDefault();

				if($(this).hasClass('disabled'))
					return false;

				if(!issend){
					issend = true;
					waitChange();
					var form_name = $(this).data("formName");
					var node = $(this).data("node");
					var order_detail = '';

					if(form_name == 'form_order'){
						var $table = $('#basket-table');
						var html = '';
						$table.find('tbody tr').each(function(){
							var $this = $(this);
							html += '<tr><td>'+$(this).find('.p-number').html()+'</td>';
							html += '<td>'+$this.find('.name a').html()+'</td>';
							html += '<td>'+$this.find('.p-code').html()+'</td>';
							html += '<td>'+$this.find('.p-packing').html()+'</td>';
							// html += '<td>'+$this.find('.p-pack').html()+'</td>';
							html += '<td>'+$this.find('.b-count input').val()+'</td>';
							html += '<td>'+$this.find('.measurement-type').val()+'</td></tr>';
						});
						order_detail = '<table border="1"><thead><tr><td>№</td><td>Наименование</td><td>Код товара</td><td>Фасовка</td>'+
						// '<td>Кол-во в упаковке</td>'+
						'<td>Количество</td><td>Ед. измерения</td></tr></thead><tbody>'+html+'</tbody></table>';
					}

					var d = {
						_do: 'get_form',
						form_name: form_name,
						order_detail: order_detail
					};
					if (node) {
						d['node'] = node;
					}

					Proj.getJSON(d, function(json){
						showForm(json, d);
					});
				}
			});
		}
	}
}();

Proj.NoveltyFilter = function() {
	var dateOptions = {
		lang: 'ru',
        format: 'd.m.Y',
        formatDate: 'd.m.Y',
        formatTime: 'H:i',
        timepicker: false,
        dayOfWeekStart: 1,
        closeOnDateSelect: true
	};

	return {
		init: function() {
			$(".f-form input[name='date_min'], .f-form input[name='date_max']").each(function() {
				var $el = $(this);
				var params = $.extend({}, dateOptions, $el.data());
				$el.datetimepicker(params);
			});
		}
	};
}()

Proj.Cookies = function() {
	return {
		init: function() {
			let cookiecook = getCookie('cookiecook');
			let cookiesBlock = $('.js-cookies');
			if (cookiecook != 'no') {
				cookiesBlock.show();
				cookiesBlock.find('.js-cookies__btn').on('click', function(e) {
					e.preventDefault();
					cookiesBlock.hide();
			        let cookieOptions = {
			            'path': '/',
			            'max-age': 60*60*24*7, // 1 week
			        };
					setCookie('cookiecook', 'no', cookieOptions);
				});
			}
		
		    function setCookie(cookieName, cookieValue, cookieOptions) {
		      cookieOptions = cookieOptions || {};
		
		      var expires = cookieOptions.expires;
		
		      if (typeof expires == "number" && expires) {
		        var d = new Date();
		        d.setTime(d.getTime() + expires * 1000);
		        expires = cookieOptions.expires = d;
		      }
		
		      if (expires && expires.toUTCString) {
		        cookieOptions.expires = expires.toUTCString();
		      }
		
		      cookieValue = encodeURIComponent(cookieValue);
		
		      var updatedCookie = cookieName + "=" + cookieValue;
		
		      for (var propName in cookieOptions) {
		        updatedCookie += "; " + propName;
		        var propValue = cookieOptions[propName];
		        if (propValue !== true) {
		          updatedCookie += "=" + propValue;
		        }
		      }
		
		      document.cookie = updatedCookie;
		    }
		
		    function getCookie(cookieName) {
		        if (typeof cookieName !== 'undefined' && cookieName !== null) {
		            var matches = document.cookie.match(new RegExp(
		                    "(?:^|; )" + cookieName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		                ));
		            return matches ? decodeURIComponent(matches[1]) : undefined;
		        }
		    }
		}
	}
}()

//------------------------------------------------------------------------------